<div *ngIf="isLoading" class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner aria-label="Loading user profile"></p-progressSpinner>
</div>

<div *ngIf="!isLoading && user" class="surface-ground h-full overflow-y-auto p-4">
    
    <div class="flex flex-wrap justify-content-between align-items-start mb-4">
        <div class="flex align-items-center">
            <div class="relative mr-4">
                <p-avatar
                    [image]="user.profilePictureUrl"
                    [label]="getInitials(user.fullName!)"
                    [styleClass]="'w-8rem h-8rem text-4xl'"
                    shape="circle"
                    (click)="fileInput.click()"
                    [style]="{'cursor': 'pointer'}">
                </p-avatar>
                <div class="absolute bottom-0 right-0">
                    <p-button icon="pi pi-camera" styleClass="p-button-rounded p-button-info" (click)="fileInput.click()" [loading]="isUploading"></p-button>
                    <input #fileInput type="file" (change)="onFileSelected($event)" hidden="true" accept="image/*" />
                </div>
            </div>
            <div>
                <h1 class="text-blue-800 text-3xl font-bold">{{ user.fullName }}</h1>
                <div class="text-white mt-2">
                    <p-chip [label]="user.roles.at(0)?.roleName" icon="pi pi-briefcase" class="bg-purple-300" />
                </div>
            </div>
        </div>
        <div>
            <p-tag [value]="user.status?.toUpperCase()" [severity]="getStatusSeverity(user.status ?? 'Active')"
                [rounded]="true" class="mr-2"></p-tag>
            <p-button label="Back" icon="pi pi-arrow-left" styleClass="p-button-text" (onClick)="goBackToList()" class="mr-2"></p-button>
            <p-button label="Edit User" icon="pi pi-pencil" (onClick)="editUser()"></p-button>
        </div>
    </div>

    <div class="card p-4 mb-4 surface-card border-round-md shadow-2">
        <div class="grid text-sm">
            <div class="col-12 md:col-6 lg:col-4"><strong>User ID:</strong> {{ user.id }}</div>
            <div class="col-12 md:col-6 lg:col-4"><strong>Email:</strong> {{ user.email }}</div>
            <div class="col-12 md:col-6 lg:col-4"><strong>Mobile:</strong> {{ user.mobileNumber || 'N/A' }}</div>
            <div class="col-12 md:col-6 lg:col-4"><strong>Created At:</strong> {{ user.createdAt | appDate:'medium' }}</div>
            <div class="col-12 md:col-6 lg:col-4"><strong>Last Updated:</strong> {{ user.updatedAt | appDate:'medium' }}</div>
        </div>
    </div>
    
    <p-panel header="Assigned Roles" styleClass="mb-4">
        <div *ngIf="(user.roles?.length ?? 0) > 0; else noRoles" class="flex flex-wrap gap-2">
            <p-chip *ngFor="let role of user.roles" [label]="role.roleName" styleClass="p-chip-lg"></p-chip>
        </div>
        <ng-template #noRoles>
            <p class="text-sm text-surface-500 dark:text-surface-400">No roles have been assigned to this user.</p>
        </ng-template>
    </p-panel>

    <p-divider></p-divider>

    <p-accordion [multiple]="true" [value]="['0']">
      <p-accordion-panel *ngFor="let access of accessLevels; let i = index" [value]="i.toString()">
          <p-accordion-header>
              {{ access.title }} ({{ access.items.length}})
          </p-accordion-header>
          <p-accordion-content>
              <div *ngIf="(access.items?.length ?? 0) > 0; else noAccess" class="flex flex-wrap gap-2">
                  <p-chip *ngFor="let item of access.items" [label]="item.name" styleClass="p-chip-sm"></p-chip>
              </div>
              <ng-template #noAccess>
                  <p class="text-sm text-surface-500 dark:text-surface-400 p-2">No access defined for this category.</p>
              </ng-template>
          </p-accordion-content>
      </p-accordion-panel>
  </p-accordion>
</div>